import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as callRoutes } from './calls/routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as dashboardAppRoutes } from './dashboardApps/routes';
import { routes as internalChatRoutes } from './internalChat/internalChat.routes';
import { routes as funnelRoutes } from './funnels/funnels.routes';
import { routes as taskRoutes } from './tasks/tasks.routes';
import appointmentsRoutes from './appointments/appointments.routes';
import quotesRoutes from './quotes/quotes.routes';
import resumesRoutes from './resumes/resumes.routes';
import timeClockRoutes from './time-clock/time-clock.routes';
import hrDashboardRoutes from './hr-dashboard/hr-dashboard.routes';
import onboardingRoutes from './onboarding/onboarding.routes';
import peopleManagementRoutes from './people-management/people-management.routes';
import terminationsRoutes from './terminations/terminations.routes';
import fiscalRoutes from './fiscal/fiscal.routes';
import stockRoutes from './stock/stock.routes';
import landingPagesRoutes from './landing-pages/landing-pages.routes';
import hospedagensRoutes from './hospedagens/hospedagens.routes';
import instagramMonitorRoutes from './instagram-monitor/instagram-monitor.routes';
import cabosEleitoraisRoutes from './cabos-eleitorais/cabos-eleitorais.routes';
import agendamentoRoutes from './agendamento/agendamento.routes';
import puxaContatoRoutes from './puxa-contato/puxa-contato.routes';
import notificacoesRoutes from './notificacoes/notificacoes.routes';
import trainingRoutes from './training/training.routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import OnboardingAccountDetails from './onboarding/Index.vue';
import OnboardingInboxSetup from './onboarding/InboxSetup.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...callRoutes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...dashboardAppRoutes,
        ...internalChatRoutes,
        ...funnelRoutes,
        ...taskRoutes,
        ...appointmentsRoutes.routes,
        ...quotesRoutes.routes,
        ...resumesRoutes.routes,
        ...timeClockRoutes.routes,
        ...hrDashboardRoutes.routes,
        ...onboardingRoutes.routes,
        ...peopleManagementRoutes.routes,
        ...terminationsRoutes.routes,
        ...fiscalRoutes.routes,
        ...stockRoutes.routes,
        ...landingPagesRoutes.routes,
        ...hospedagensRoutes.routes,
        ...instagramMonitorRoutes.routes,
        ...cabosEleitoraisRoutes.routes,
        ...agendamentoRoutes.routes,
        ...puxaContatoRoutes.routes,
        ...notificacoesRoutes.routes,
        ...trainingRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/onboarding'),
      name: 'onboarding_account_details',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingAccountDetails,
    },
    {
      path: frontendURL('accounts/:accountId/onboarding/inbox-setup'),
      name: 'onboarding_inbox_setup',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: OnboardingInboxSetup,
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
